import type { FaireProductEntity } from "../../entity_types/product";

export const p_7s2p2guseh: FaireProductEntity = {
  token: "p_7s2p2guseh",
  type: "product",
  name: "Women's Winter Thick Knit Nordic Cabin Crew Socks - Snow",
  brandName: "7DAYSSOCKS",
  imageUrl:
    "https://cdn.faire.com/fastly/91d0cf6cac16186943fdae8b1e5293393b0815d494945ef710eba45c1f143562.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/640fdef74155edc13702a566fee8063bc5a143b3df4bba2976b3215efb614b2c.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
